import React, { useState, useEffect } from "react";
import { Container, Button, Tabs, Tab } from "react-bootstrap";
import Categories from "./Categories/index";
import Products from "./Products/index";
import Orders from "./Orders/index";
import AdminPanelLogin from "../AdminPanelLogin/index";
import ShowPrice from "./ShowPrice/index";
import {
  getCategories,
  getProducts,
  getOrders,
  getSubCategories,
  getStorePickupData,
  isSuperAdminLoggedIn,
  removeSuperAdminLoginDate,
  getDeliveryState,
} from "../../../helper";
import StorePickup from "./StorePickup";
import Delivery from "./Delivery";
import DelhiveryRequestPickup from "./DelhiveryRequestPickup";

export default function AdminPanelHome() {
  const [loggedIn, setLoggedIn] = useState(isSuperAdminLoggedIn());
  const [showPriceValue, setShowPriceValue] = useState(null);
  const [categories, setCategories] = useState(null);
  const [products, setProducts] = useState(null);
  const [orders, setOrders] = useState(null);
  const [productsCount, setProductsCount] = useState(null);
  const [subCategories, setSubCategories] = useState(null);
  const [storePickupCounter, setStorePickupCounter] = useState(null);
  const [ordersCount, setOrdersCount] = useState(null);
  const [storePickupSlots, setStorePickupSlots] = useState(null);
  const [deliveryState, setDeliveryState] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!loading) {
      setLoading(true);
      Promise.all([
        fetchCategories(),
        fetchProducts(),
        fetchDeliveryState(),
        fetchSubCategories(),
        fetchOrders({ pageNo: 1 }),
        fetchStorePickupCounter(),
        fetchDeliveryState(),
      ]);
    }
  }, [loading]);

  const fetchDeliveryState = async () =>
    await getDeliveryState().then((result) => setDeliveryState(result));

  const fetchStorePickupCounter = async () =>
    await getStorePickupData().then((result) => {
      setStorePickupCounter(result.counter);
      setStorePickupSlots(result.time_slots);
    });

  const fetchSubCategories = async () =>
    await getSubCategories().then((result) => setSubCategories(result));

  const addSubCategory = (subCategory) => {
    const newSubCategories = Object.assign([], subCategories);
    newSubCategories.push(subCategory);
    setSubCategories(newSubCategories);
  };

  const fetchProducts = async (searchString, categoryId, pageNo = 1) => {
    var query = { searchString: searchString || "", pageNo, perPage: 20 };
    if (categoryId) {
      query.categoryId = categoryId;
    }
    await getProducts(query).then((result) => {
      setProducts(result.products);
      setProductsCount(result.count);
    });
  };

  const fetchCategories = async () => {
    await getCategories().then((result) => {
      setCategories(result.categories);
      if (!showPriceValue) {
        setShowPriceValue(result.showPriceValue);
      }
    });
  };

  const fetchOrders = async (options) => {
    await getOrders(options).then((result) => {
      setOrders(result.orders || []);
      setOrdersCount(result.count || 0);
    });
  };

  return !loggedIn ? (
    <AdminPanelLogin setLoggedIn={setLoggedIn} />
  ) : (
    <div>
      <div className="d-flex justify-content-end">
        <Button
          onClick={() => {
            setLoggedIn(false);
            removeSuperAdminLoginDate();
          }}
        >
          Logout
        </Button>
      </div>
      <Container className="mb-5">
        {products && categories && orders && (
          <Tabs defaultActiveKey="Orders">
            <Tab eventKey="Categories" title="Categories">
              <Categories
                fetchCategories={fetchCategories}
                categories={categories}
                setCategories={setCategories}
              />
            </Tab>
            <Tab eventKey="Products" title="Products">
              <Products
                products={products || []}
                setProducts={setProducts}
                fetchProducts={fetchProducts}
                categories={categories}
                productsCount={productsCount}
                subCategories={subCategories || []}
                addSubCategory={addSubCategory}
              />
            </Tab>
            <Tab eventKey="Orders" title="Orders">
              <Orders
                orders={orders}
                setOrders={setOrders}
                fetchOrders={fetchOrders}
                ordersCount={ordersCount}
              />
            </Tab>
            {showPriceValue !== undefined && showPriceValue !== null && (
              <Tab eventKey="ShowPrice" title="Show Price">
                <ShowPrice
                  showPriceValue={showPriceValue}
                  setShowPriceValue={setShowPriceValue}
                />
              </Tab>
            )}
            <Tab eventKey="StorePickup" title="Store Pickup">
              <StorePickup
                storePickupCounter={storePickupCounter}
                storePickupSlots={storePickupSlots}
                fetchStorePickupCounter={fetchStorePickupCounter}
              />
            </Tab>
            <Tab eventKey="DeliveryState" title="Delivery State">
              <Delivery
                setDeliveryState={setDeliveryState}
                deliveryState={deliveryState}
              />
            </Tab>
            <Tab
              eventKey="DelhiveryRequestPickup"
              title="Delhivery Request Pickup"
            >
              <DelhiveryRequestPickup />
            </Tab>
          </Tabs>
        )}
      </Container>
    </div>
  );
}
